"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.StyledListItem = exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const SvgIcon_1 = require("@mui/material/SvgIcon");
const PREFIX = "IconList";
exports.classes = {
    isCompact: `${PREFIX}-isCompact`,
    icon: `${PREFIX}-icon`,
    description: `${PREFIX}-description`
};
exports.Root = (0, styles_1.styled)("ul")(() => ({
    margin: 0,
    paddingLeft: 0,
    [`.${exports.classes.isCompact}`]: {
        marginBottom: 0,
        [`.${exports.classes.description}`]: {
            marginTop: 0,
            marginBottom: "20px"
        }
    },
    [`.${exports.classes.icon}`]: {
        marginRight: "12px",
        [`.${SvgIcon_1.svgIconClasses.root}`]: {
            fontSize: "24px",
            display: "block"
        }
    },
    [`.${exports.classes.description}`]: {
        marginTop: "20px"
    }
}));
exports.StyledListItem = (0, styles_1.styled)("li")({
    marginBottom: "40px",
    display: "flex",
    "&:not(:last-of-type)": {
        marginBottom: "6px"
    }
});
exports.Content = (0, styles_1.styled)("div")({
    display: "flex",
    flexDirection: "column",
    wordBreak: "break-word"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ljb24tbGlzdC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsaURBQThDO0FBQzlDLG1EQUF1RDtBQUV2RCxNQUFNLE1BQU0sR0FBRyxVQUFVLENBQUM7QUFFYixRQUFBLE9BQU8sR0FBRztJQUNyQixTQUFTLEVBQUUsR0FBRyxNQUFNLFlBQVk7SUFDaEMsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0lBQ3RCLFdBQVcsRUFBRSxHQUFHLE1BQU0sY0FBYztDQUNyQyxDQUFDO0FBRVcsUUFBQSxJQUFJLEdBQUcsSUFBQSxlQUFNLEVBQUMsSUFBSSxDQUFDLENBQUMsR0FBRyxFQUFFLENBQUMsQ0FBQztJQUN0QyxNQUFNLEVBQUUsQ0FBQztJQUNULFdBQVcsRUFBRSxDQUFDO0lBQ2QsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxTQUFTLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLFlBQVksRUFBRSxDQUFDO1FBQ2YsQ0FBQyxJQUFJLGVBQU8sQ0FBQyxXQUFXLEVBQUUsQ0FBQyxFQUFFO1lBQzNCLFNBQVMsRUFBRSxDQUFDO1lBQ1osWUFBWSxFQUFFLE1BQU07U0FDckI7S0FDRjtJQUNELENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNwQixXQUFXLEVBQUUsTUFBTTtRQUNuQixDQUFDLElBQUksd0JBQWMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1lBQzNCLFFBQVEsRUFBRSxNQUFNO1lBQ2hCLE9BQU8sRUFBRSxPQUFPO1NBQ2pCO0tBQ0Y7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7UUFDM0IsU0FBUyxFQUFFLE1BQU07S0FDbEI7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsY0FBYyxHQUFHLElBQUEsZUFBTSxFQUFDLElBQUksQ0FBQyxDQUFDO0lBQ3pDLFlBQVksRUFBRSxNQUFNO0lBQ3BCLE9BQU8sRUFBRSxNQUFNO0lBQ2Ysc0JBQXNCLEVBQUU7UUFDdEIsWUFBWSxFQUFFLEtBQUs7S0FDcEI7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLE9BQU8sR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNuQyxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLFNBQVMsRUFBRSxZQUFZO0NBQ3hCLENBQUMsQ0FBQyJ9